export default __webpack_public_path__ + "static/media/closet2-768w.923924f6.png";